
import { Button, CircularProgress } from '@material-ui/core'
import { useStyles } from './style'

const ButtonWithSpinner = ({ loading, children, ...rest }) => {
  const classes = useStyles()

  return (
    <Button
      className={classes.button}
      disabled={loading}
      {...rest}
      variant="contained"
      disableElevation
    >
      {children}
      {loading && (
        <CircularProgress size={24} className={classes.buttonProgress} />
      )}
    </Button>
  )
}

export default ButtonWithSpinner
